module.exports = __webpack_public_path__ + "img/greeting.2422751c.png";